const config = {
  defaultPath: "/",
  fontFamily: `'Poppins', sans-serif`,
  borderRadius: 4,
  years: ["2026"],
};

export default config;
